module.exports = __webpack_public_path__ + "img/btn_servik_active.3d005339.svg";